import { Outlet } from "react-router-dom";
import "./Public.style.scss";

type P_Props = {};

const PublicLayout = (props: P_Props) => {
  return (
    <div className="layout-public">
      <div className="layout-public__content">
        <Outlet />
      </div>
    </div>
  );
};

export default PublicLayout;
